import { DateField, EditButton, TextField } from "react-admin";

import Card from "./Card";
import Filters from "./Filters";
import IconField from "./fields/IconField";
import React from "react";
import ResponsiveGrid from "../components/list/ResponsiveGrid";
import ResponsiveList from "../components/list/ResponsiveList";

const List = (props) => (
  <ResponsiveList
    {...props}
    filters={<Filters />}
    split
    type="table"
    perPage={10}
    exporter={false}
  >
    <ResponsiveGrid rowBreakpoint="sm" cardContent={<Card />}>
      <TextField source="id" />
      <IconField source="icon" sortable={false} />
      <TextField source="code" variant="body2" />
      <TextField source="name" />
      <DateField source="modified" showTime />
      <EditButton />
    </ResponsiveGrid>
  </ResponsiveList>
);
export default List;
